module.exports = __webpack_public_path__ + "static/media/avatar37.1fe83b62.png";